import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { MailToLink } from 'ia-react-core';
import { Advisor as IAdvisor } from '../../../../../interfaces/Advisors';
import { StyledInformation } from '../Content.styles';
import Section from '../../../../../components/Section';
import Content2 from '../../../ContactInformation/Content';
import Phones from '../Phones';

export interface AdvisorProps {
  advisor: IAdvisor;
}

const Advisor: FC<AdvisorProps> = ({ advisor }) => {
  const { t } = useTranslation('ContactUsPage');
  return (
    <StyledInformation>
      <Phones data-testid="advisorPhone" phones={advisor?.phones} />
      {
        advisor?.email &&
        <Section name={t('email')}>
          <Content2 data-testid="advisorEmail" lines={[<MailToLink email={advisor.email}>{advisor.email}</MailToLink>]} />
        </Section>
      }
    </StyledInformation>

  );
};

export default Advisor;
